/* Presentation enhancement only: mark existing numbered Terms headings. */
(() => {
  const markHeadings = () => {
    if (window.location.pathname !== '/policies/terms-of-service') return;
    document.querySelectorAll('.shopify-policy__body p').forEach((paragraph) => {
      if (/^\d+\.\s+[^\n]+$/.test(paragraph.textContent.trim()) && paragraph.textContent.trim().length < 90) {
        paragraph.classList.add('ch21-policy-section-heading');
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markHeadings, { once: true });
  else markHeadings();
  document.addEventListener('shopify:section:load', markHeadings);
})();
